<template>

  <div>
    <div class="row  no-gutters pt-xl-4 mb-xl-6">
      <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

      </div>
      <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
           v-if="lesson">
        {{ lesson.lesson }}
      </div>
      <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
        <div class="zerno-points">
          {{ points }}
        </div>
      </div>
      <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
        <div class="tab-video-notice-1">{{ $t('test') }} {{ $t('№') }}{{ test.pos }}
          <span class="ml-2" v-if="testsCount > 0">({{ test.pos }} {{ $t('of') }} {{ testsCount }})</span>
        </div>
      </div>

      <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

        <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
        <h2 class="mt-7" v-else>{{ $t('test') }} {{ $t('№') }}{{ test.pos }}</h2>
        <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
        <button
            class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
            @click="startTest">
          <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{ $t('№') }}{{ test.pos }}
        </button>

      </div>

      <div class="col-12 order-10" v-if="!showTestIntro && test">

        <div class="row ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

          <div class="col-xl-12 col-12 test-question-content text-center mt-xl-n4"
               v-if="currentTask.testtask && !complete">
                        <span v-if="currentTask.pos && !currentTask.testtask.startsWith($t('№')+currentTask.pos)"
                              class="mr-3">{{ $t('№') }}{{ currentTask.pos }}.</span>{{ currentTask.testtask }}
          </div>

          <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
               v-if="test.description && test.description !== currentTask.testtask && !complete">{{
              test.description
            }}
          </div>

          <div v-if="testmode==0 && complete" class="row">
            <div class="col-12 mb-4 text-center">
              <img src="poliimg/excellent.png"
                   class="test-image"
                   style="width: 250px"
              >
            </div>
          </div>
          <div v-else class="col-12">
            <div class="row justify-content-center text-center no-gutters">

              <div :class="['col-lg-'+widthcol, 'col-12', 'mb-xl-4', 'mb-4', 'mt-3']">
                <div class="row no-gutters justify-content-lg-center justify-content-around">
                  <div
                      v-for="(item,ind) in testelementsDropZone"
                      :key="'zone' + ind"
                      :class="['col-lg-4', 'col-3', 'testcard-sqr', 'testcard-border', 'text-center', 'm-lg-2', 'mb-2', item.type]"
                  >
                    <div>
                      <transition name="fade">
                        <div v-show="testelementsDropZone[ind].visible" class="ma-0 pa-0">
                          <container
                              group-name="col"
                              :should-accept-drop="(src, payload) => { return testelementsDropZone[ind].child.length===0 || payload===testelementsDropZone[ind].child[0] }"
                              :get-child-payload="getCardPayload(ind)"
                              drag-class="card-ghost"
                              no-drop-class="card-ghost-drop"
                              :drop-placeholder="dropPlaceholderOptions"
                              @drop="(e) => onCardDrop(ind, e)"
                          >
                            <draggable
                                v-for="child in testelementsDropZone[ind].child"
                                :key="child.idtestelement"
                                @touchmove.native="draggableMove"
                            >
                              <div class="text-center text-center d-flex align-items-center justify-content-center"
                                   style="width: 90px; height: 90px;">
                                <img
                                    v-if="child.image"
                                    class="my-1 test-image"
                                    style="pointer-events: none; max-width: 100%; max-height: 100%;"
                                    :src="child.image"
                                />
                                <div v-else class="drop-word">
                                  {{ child.word }}
                                </div>
                              </div>
                            </draggable>
                          </container>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="row justify-content-center text-center no-gutters">
              <button
                  v-if="step==0 && !currentTask.intvl"
                  class="btn btn-info mb-2"
                  @click="showHeap"
              >
                Я запомнил
              </button>
            </div>

            <div class="row justify-content-center text-center no-gutters">
              <button
                  v-if="testmode==1 && done"
                  class="btn btn-info mt-2"
                  @click="next"
              >
                {{ $t('accept_answer') }}
              </button>
            </div>

          </div>

          <div class="col-lg-1 col-12 text-lg-right text-center">
            <button
                v-if="!complete"
                class="btn btn-info mt-lg-5 w-100"
                @click="scrollHeap('left')"
            >
              <i style="" class="fa fa-arrow-left"></i>
            </button>
          </div>
          <div
              v-if="!complete"
              class="col-lg-10 col-12 mb-xl-4 mb-4 mt-2 drop-wrapper"
              style="overflow: hidden;"
              id="cardsheap"
          >
            <div :style="{ height: '135px', maxHeight: '135px', width: widthscoll }">
              <container
                  :orientation="'horizontal'"
                  group-name="col"
                  :should-accept-drop="() => { return step>0; }"
                  :get-child-payload="index => {return this.testelementsHeap[index]}"
                  class="ma-4 row"
                  style="height: 100px;"
                  @drop="onDrop"
              >
                <draggable
                    style="height: 135px;"
                    v-for="child in testelementsHeap"
                    :key="child.idtestelement"
                    @touchmove.native="draggableMove"
                >
                  <div
                      class="mx-2 my-3 testcard-border testcard-sqr text-center d-flex align-items-center justify-content-center">
                    <img
                        v-if="child.image"
                        class="my-1 test-image"
                        style="pointer-events: none; max-width: 95px; max-height: 100px;"
                        :src="child.image"
                    />
                    <div v-else class="drop-word">
                      {{ child.word }}
                    </div>
                  </div>
                </draggable>
              </container>
            </div>
          </div>
          <div class="col-lg-1 col-12 text-lg-right text-center">
            <button
                v-if="!complete"
                class="btn btn-info mt-lg-5 w-100"
                @click="scrollHeap('right')"
            >
              <i style="" class="fa fa-arrow-right"></i>
            </button>
          </div>

        </div>

      </div>


    </div>
    <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
      <button
          class="btn btn-info"
          @click="skip"
      >
        {{ $t('omit_task') }} &rarr;
      </button>
    </div>
  </div>

</template>

<style src="@/assets/poliglotiki/main.css">
</style>
<script>

import api from '@/utils/api'
import {Container, Draggable} from 'vue-smooth-dnd'

export default {
  name: 'Test34',
  components: {
    Container,
    Draggable,
  },
  props: {
    idtest: {default: null},
    lesson: {type: Object, default: null},
    points: {default: null},
    testsCount: {default: null},
    showButtons: {type: Boolean, default: true},
    testmode: {default: 0},
  },
  data: () => ({
    test: {},
    testtasks: [],
    testelements: [],
    taskIdx: 0,
    audio: new Audio(),
    done: false,
    complete: false,
    errorCount: 0,
    step: 0,
    widthcol: 12,

    testelementsDropZone: [],
    testelementsHeap: [],

    forceRenderKey: 0,

    upperDropPlaceholderOptions: {
      className: 'cards-drop-preview',
      animationDuration: '150',
      showOnTop: true,
    },
    dropPlaceholderOptions: {
      className: 'drop-preview',
      animationDuration: '150',
      showOnTop: true,
    },

    showTestIntro: true,

    //errorChord: 'gong.mp3',
    errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
    okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
  }),

  computed: {
    currentTask: function () {
      return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
    },
    widthscoll() {
      if (this.testelementsHeap)
        return String(Math.round(this.testelementsHeap.length * 118) + 118) + "px"
      return '2500px';
    }
  },

  watch: {
    taskIdx: function () {
      this.loadTask()
    },
  },

  async mounted() {
    api({url: '/tests/' + this.idtest}).then(resp => {
      this.test = resp.data
    })
    const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
    this.testtasks = response.data
    // workaround for "once smooth-dnd is touched, can not scroll any more page" https://github.com/kutlugsahin/smooth-dnd/issues/83#issuecomment-713486752
    const cleanClasses = () => {
      document.body.className = '';
    };
    document.addEventListener('touchend', cleanClasses, false);
  },

  methods: {
    async startTest() {
      if (this.testtasks.length) {
        if (this.test.audio) {
          await this.play(this.test.audio)
        }
        this.showTestIntro = false
        this.loadTask()
      }
    },
    async loadTask() {
      if (this.currentTask.idtesttask) {
        const response = await api({
          method: 'get',
          url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
        })

        this.step = 0
        this.done = false
        this.complete = false

        this.testelements = response.data
        this.widthcol = Math.ceil(Math.sqrt(this.testelements.length) * 1.5)

        // if (this.testelements.length && this.testelements[0].pos === null)
        this.testelements = this.shuffle(this.testelements)

        this.testelementsDropZone = []
        for (let index = 0; index < this.testelements.length; index++) {
          this.testelementsDropZone.push({
            visible: false,
            idtestelement: this.testelements[index].idtestelement,
            word: this.testelements[index].word,
            type: '',
            child: [this.testelements[index]]
          })
        }

        this.testelementsHeap = []
        this.showByInterval(this.currentTask.intvl | 0);
      } else {
        this.$emit('testComplete')
      }

    },

    showHeap() {
      this.step = 1

      for (let index = 0; index < this.testelementsDropZone.length; index++) {
        this.testelementsDropZone[index].child = []
      }
      this.testelementsHeap = this.shuffle([...this.testelements])

      for (let index = 0; index < this.testelementsDropZone.length; index++) {
        this.testelementsDropZone[index].visible = true
      }
    },

    async showByInterval(intvl) {
      intvl = parseInt(intvl)
      if (intvl) await this.sleep(2000)
      for (let index = 0; index < this.testelementsDropZone.length; index++) {
        this.testelementsDropZone[index].visible = true
        if (intvl) {
          console.log('sleep')
          await this.sleep(intvl * 1000)
          this.testelementsDropZone[index].visible = false
        }
      }

      if (intvl) {
        await this.sleep(3000)
        this.showHeap()
      }
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    getBy(propname, value, array) {
      for (let index = 0; index < array.length; index++) {
        if (array[index][propname] === value) return array[index]
      }

      return {}
    },

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]]
      }
      return a
    },

    play: function (path) {
      return new Promise((resolve) => {
        if (path) {
          this.audio.src = path
          this.audio.play()
          this.audio.onended = function () {
            // console.log('Звук закончился')
            resolve()
          }

          this.audio.onerror = function () {
            console.log('Звук error')
            resolve()
          }
        } else {
          resolve()
        }
      })
    },
    next: async function () {
      if (this.complete) {
        this.$emit('correctAnswer')
        if (this.testmode == 0) await this.sleep(3000)
      } else this.$emit('wrongAnswer', {
        test: this.test.test,
        taskIdx: this.taskIdx,
        error: `Неправильно соединено элементов: ${this.errorCount}.`
      })
      this.taskIdx++
    },

    skip: function () {
      this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
      this.taskIdx++
    },

    async scrollHeap(direction) {
      for (let i = 0; i < 180; i++) {
        document.getElementById('cardsheap').scrollLeft += (direction == 'left' ? -1 : 1)
        await this.sleep(3)
      }
    },

    onDrop(dropResult) {
      this.testelementsHeap = this.applyDrag(this.testelementsHeap, dropResult)
    },

    draggableMove(e) {
      // Для автопрокрутки страницы на малых экранах, когда обсласти Drag&Drop не помещаются
      const offset = 50
      const scrollStep = 20
      const clientY = e.touches[0].clientY
      const viewportHeight = document.documentElement.clientHeight;
      if (clientY > (viewportHeight - offset))
        window.scrollBy(0, scrollStep);
      if (clientY < offset)
        window.scrollBy(0, -scrollStep);
    },

    async onCardDrop(zoneIdx, dropResult) {
      // console.log('drop ' + zoneIdx, dropResult, this.testelementsDropZone)
      this.testelementsDropZone[zoneIdx].child = this.applyDrag(this.testelementsDropZone[zoneIdx].child, dropResult)

      if (dropResult.addedIndex === null) {
        this.testelementsDropZone[zoneIdx].type = ''
      } else if (this.testmode == 1) {
        this.testelementsDropZone[zoneIdx].type = 'card-answered'
        this.testelementsDropZone[zoneIdx].correct = (dropResult.payload.idtestelement === this.testelementsDropZone[zoneIdx].idtestelement)
        await this.play(this.okChord)
      } else if (dropResult.payload.idtestelement === this.testelementsDropZone[zoneIdx].idtestelement) {
        this.testelementsDropZone[zoneIdx].correct = true
        this.testelementsDropZone[zoneIdx].type = 'card-correct'
        if (dropResult.payload.audio) {
          await this.play(dropResult.payload.audio)
        } else {
          await this.play(this.okChord)
        }
      } else {
        this.testelementsDropZone[zoneIdx].correct = false
        this.testelementsDropZone[zoneIdx].type = 'card-wrong'
        await this.play(this.errorChord)
      }

      let done = true // все ответы выбраны
      this.errorCount = 0
      this.testelementsDropZone.forEach(function (zone) {
        if (zone.correct !== true) this.errorCount++
        if (zone.correct !== true && zone.correct !== false) done = false
      }, this)
      this.complete = !this.errorCount
      this.done = done

      if (this.testmode == 0 && this.complete) {
        this.next()
      }
    },
    getCardPayload(zoneIdx) {
      return index => {
        return this.testelementsDropZone[zoneIdx].child[index]
      }
    },
    log(...params) {
      console.log(...params)
    },

    applyDrag(arr, dragResult) {
      const {removedIndex, addedIndex, payload} = dragResult
      if (removedIndex === null && addedIndex === null) return arr

      const result = [...arr]
      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }

      return result
    },

  },
}
</script>

<style scoped>

@media (max-width: 1199.98px) {
  .smooth-dnd-container {
    min-height: 100px !important;
  }
}

.smooth-dnd-container {
  min-height: 150px;
  width: 100%;
  padding: 0;
  margin: 0;
  display: inline-block !important;
}

.smooth-dnd-draggable-wrapper {
  display: inline-block !important;
}

.form-ghost {
  transition: 0.18s ease;
  box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.08);
}

.card-ghost {
  border: 1px dashed #abc;
}

.form-ghost-drop {
  box-shadow: 0 0 2px 5px rgba(0, 0, 0, 0.0);
}

.drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px;
}

.cards-drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px 45px 5px 5px;
}
</style>
